import { Theme } from '@mui/material/styles';
import {checkboxClasses} from "@mui/material/Checkbox";

// ----------------------------------------------------------------------

export function checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '0px',
          paddingRight: theme.spacing(1),
          color: theme.palette.eliga_EDA.main,
          [`&.${checkboxClasses.checked}`]: {
            color: theme.palette.eliga_2EC.main
          },
          [`&.${checkboxClasses.disabled}`]: {
            color: theme.palette.eliga_EDA.main,
            opacity: '0.4'
          },
        }
      },
    },
  };
}
